export default __webpack_public_path__ + "assets/audios/0e245fb5b0e8bb9d0b5e5914e236e883.mp3";